
export default {
  props: ['stepNumber', 'totalSteps'],
  computed: {
    achieved() {
      return this.totalSteps >= this.stepNumber;
    }
  }
}
